import React, { useState, useEffect } from "react";

import { GeneralModal, Datepicker } from "components";

import { func_validation } from "functions";
import useMobileLicenseKey from "dataflow/billingPortal/actions/useMobileLicenseKey.actions";


export function useSetDeletedDate({ comId }) {

    const { updateDeleteDate } = useMobileLicenseKey();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [deleteDate, setdeleteDate] = useState();
    const [licenseKey, setlicenseKey] = useState();

    function updateModalState(value) {
        setIsModalVisible(true)
        setlicenseKey(value?.LicenseKey)
    }

    useEffect(() => {
        if(!isModalVisible) {
            setlicenseKey(undefined)
            setdeleteDate(undefined)
        }
    }, [isModalVisible])

    let modalDisplay = (
        <GeneralModal
            modalWapperClassName={"mobile-license-key__deletedDataModal"}
            isModalVisible={isModalVisible}

            title={"Scheduled Deletion Date"}
            headerClassName={"mobile-license-key__deletedDataModal-header"}
            updateParentState={setIsModalVisible}

            bodyWrapperClassName={"mobile-license-key__deletedDataModal-bodyWrapper"}
            contentClassName={"mobile-license-key__deletedDataModal-content"}
            content={(
                <Datepicker
                    isInputRequired
                    label={"Set a date to delete"}
                    defaultDate={deleteDate}
                    handleOnChange={setdeleteDate}
                    isResetRequired={isModalVisible}
                    otherOptions={{
                        maxDate: new Date()
                    }}
                />
            )}

            footerClassName={"mobile-license-key__deletedDataModal-footer"}
            confirmButtonText={"Save"}
            footerCancelWrapperClassName={"px-2"}
            footerCancelClassName={"mobile-license-key__deletedDataModal-footer__cancel-button"}
            footerConfirmWrapperClassName={"px-2"}
            cancelButtonText={"Cancel"}
            handleOnConfirm={() => {
                if(func_validation.isNotNullUndefined(deleteDate)) {
                    updateDeleteDate(comId, licenseKey, deleteDate)
                    setIsModalVisible(false)
                }
            }}
            isCancelButtonVisible isConfirmButtonVisible
        />
    );

    return {
        modalDisplay,
        updateModalState
    }
}